module.exports = __webpack_public_path__ + "img/3.030cca6f.jpg";